import init from './_init';
import auth from './_auth.js';
import { combineReducers } from 'redux';
const rootReducer = combineReducers({
  init,
  auth
});
export default rootReducer;
